import { render, staticRenderFns } from "./m_AllAssignments.vue?vue&type=template&id=33b32994&scoped=true&"
import script from "./m_AllAssignments.vue?vue&type=script&lang=js&"
export * from "./m_AllAssignments.vue?vue&type=script&lang=js&"
import style0 from "./m_AllAssignments.vue?vue&type=style&index=0&id=33b32994&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b32994",
  null
  
)

export default component.exports